import { useCallback, useState } from 'react'
import { FiTrash2, FiX } from 'react-icons/fi'

import { Button } from '~/components/Button'
import { Modal } from '~/components/Modal'
import { deleteInvoice } from '~/modules/sales/services'
import { insertToast } from '~/modules/toasts/services'

type Props = {
  invoiceId: string
  onDelete: () => void
}

export const DeleteInvoiceButton: React.FC<Props> = ({
  invoiceId,
  onDelete,
}) => {
  const [showModal, setShowModal] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)

  const handleToggleModal = useCallback(() => {
    setShowModal((state) => !state)
  }, [])

  const handleDeletePlan = useCallback(() => {
    setLoading(true)
    deleteInvoice(invoiceId).then((success) => {
      if (success) {
        setShowModal(false)
        insertToast({
          title: 'Sucesso!',
          message: 'Assinatura cancelada',
          duration: 3,
        })
        onDelete()
      } else {
        insertToast({
          title: 'Erro',
          message: 'Falha ao realizar ação',
          type: 'error',
          duration: 3,
        })
      }
      setLoading(false)
    })
  }, [invoiceId, onDelete])

  return (
    <>
      <button
        type='button'
        className='py-2 px-4 rounded-md bg-gpa-red hover:bg-red-500 text-white'
        onClick={handleToggleModal}
      >
        <FiTrash2 size={18} />
      </button>
      <Modal visible={showModal}>
        <div className='grid gap-4'>
          <div className='flex items-center justify-between mb-4'>
            <h1 className='text-xl'>Cancelar uma fatura</h1>
            <button
              type='button'
              className='p-2 rounded-full hover:bg-slate-50'
              onClick={handleToggleModal}
            >
              <FiX size={26} />
            </button>
          </div>
          <p>
            Ao cancelar uma fatura, <b>o valor será estornado</b>. Essa ação é,
            obviamente, irreversível.
          </p>

          <div className='flex justify-end'>
            <Button
              type='button'
              color='error'
              disabled={loading}
              loading={loading}
              onClick={handleDeletePlan}
              loadingMessage='Deletando...'
            >
              Cancelar fatura
            </Button>
          </div>
        </div>
      </Modal>
    </>
  )
}
